module.exports = __webpack_public_path__ + "img/claim.fed42646.svg";